import { c as _c } from "react/compiler-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import { createContext, useContext, useMemo, type JSX } from 'react';
import * as React from 'react';
import { core } from 'smartystreets-javascript-sdk';
import type { InternationalClient as SmartyStreetsInternationalClient } from '../types';

/**
 * Data stored in RequestContext
 */
export interface SmartyStreetsInternationalContextData {
  internationalStreetClient: SmartyStreetsInternationalClient;
}

/**
 * When the hook is called the SmartyStreets client must be available
 * on this context object.
 */
export const SmartyStreetsInternationalContext = createContext<SmartyStreetsInternationalContextData | null>(null);

/**
 * Provider props
 */
interface ProviderProps {
  apiKey: string;
  children: React.ReactNode;
}

/**
 * Access the SmartyStreets client directly.
 * Throw an error if client is undefined
 */
export function useSmartyStreetsInternationalClient() {
  const client = useContext(SmartyStreetsInternationalContext);
  if (!client) {
    throw new Error("SmartyStreets client must be set on SmartyStreetsInternationalContext");
  }
  return client;
}

/**
 * Create the SmartyStreets client
 */
export function SmartyStreetsInternationalProvider(props) {
  const $ = _c(7);
  const {
    apiKey,
    children
  } = props;
  let t0;
  let t1;
  if ($[0] !== apiKey) {
    const credentials = new core.SharedCredentials(apiKey);
    const clientBuilder = new core.ClientBuilder(credentials);
    t1 = clientBuilder.buildInternationalStreetClient();
    $[0] = apiKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      internationalStreetClient: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  t0 = t2;
  const client = t0;
  let t3;
  if ($[4] !== children || $[5] !== client) {
    t3 = <SmartyStreetsInternationalContext.Provider value={client}>{children}</SmartyStreetsInternationalContext.Provider>;
    $[4] = children;
    $[5] = client;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
}